import { useParams } from 'react-router-dom';

import { trackEvent } from '@/analytics/trackEvent';
import { useBoard } from '@/hooks/boards-hooks';
import { useCurrentChannel } from '@/hooks/query/useCurrentChannel';
import { useQueryParams } from '@/hooks/useQueryParams';
import type { FeedItemType, RouteParam } from '@/types';

export const useTrackSourceCards = (result: FeedItemType) => {
  const { board_name } = useBoard();
  const { name: channel_name } = useCurrentChannel();
  const { subCategory } = useParams<RouteParam>();
  const [q] = useQueryParams();

  const trackSourceCard = () =>
    trackEvent('card_clicked', {
      source: result.label || result.source,
      feed_name: channel_name || board_name || q.search_type || 'home',
      search_term: q.q ?? '',
      tab_name: subCategory,
    });
  return { trackSourceCard };
};
